// extracted by mini-css-extract-plugin
export var table = "_xd-0";